import { generateRandomString } from "./utils";

const topics = [
  {
      name: "Refunds",
      category: "Sales, Logistics",
      conversations: 172,
      comparePreviousPeriod: {
        atmosphere: "positive",
        conversations: 50,
        durationAvg: 20
      },
      atmosphere: {
        mainSentiment: "negative",
        mainSentimentPercent: 10,
      },
      duration: {
        avg: 100
      },
      relatedTopics: {
          topicId: generateRandomString(),
          name: "topic there 2",
          percent: 40,
      },
      touchPoint: {
        text: { type: 'text', value: "100%"},
        voice: { type: 'voice', value: "88%"},
      },
      otherTopics: [
        {
          topicId: "14",
          name: "cas oui hésitez",
          percent: 58
        },
        {
            topicId: "28",
            name: "accord montant tarif",
            percent: 10
        },
        {
            topicId: "3",
            name: "ensemble civile savoir",
            percent: 30
        }
      ]
  },
  {
    topicId: generateRandomString(),
    name: "Delivery",
    category: "Sales, Logistics",
    conversations: 113,
    comparePreviousPeriod: {
      atmosphere: "negative",
      conversations: -5.6,
      durationAvg: -4.5
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 72,
    },
    duration: {
      avg: 142
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 40,
    },
    touchPoint: {
      text: { type: 'text', value: "80%"},
      voice: { type: 'voice', value: "67%"},
    },
    otherTopics: [
      {
        topicId: "14",
        name: "tarif journalier",
        percent: 48
      },
      {
          topicId: "28",
          name: "acte juridique",
          percent: 40
      },
      {
          topicId: "3",
          name: "bon de commande",
          percent: 68
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Certificate",
    category: "Paperwork",
    conversations: 53,
    comparePreviousPeriod: {
      atmosphere: "negative",
      conversations: -8.2,
      durationAvg: 6
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 25,
    },
    duration: {
      avg: 142
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 40,
    },
    touchPoint: {
      text: { type: 'text', value: "90%"},
      voice: { type: 'voice', value: "57%"},
    },
    otherTopics: [
      {
        topicId: "54",
        name: "produit defectant",
        percent: 4
      },
      {
          topicId: "457",
          name: "agence voyage",
          percent: 80
      },
      {
          topicId: "6357",
          name: "frais livraison gratuit",
          percent: 19
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Product info",
    category: "SALES",
    conversations: 32,
    comparePreviousPeriod: {
      atmosphere: "positive",
      conversations: 4.3,
      durationAvg: 1.2
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 32,
    },
    duration: {
      avg: 186
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 53,
    },
    touchPoint: {
      text: { type: 'text', value: "50%"},
      voice: { type: 'voice', value: "67%"},
    },
    otherTopics: [
      {
        topicId: "6924",
        name: "date limite",
        percent: 40
      },
      {
          topicId: "784",
          name: "prix total",
          percent: 8
      },
      {
          topicId: "124",
          name: "consommation globale",
          percent: 75
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Tracking",
    category: "LOGISTIC",
    conversations: 17,
    comparePreviousPeriod: {
      atmosphere: "negative",
      conversations: -7.3,
      durationAvg: 3.4
    },
    atmosphere: {
      mainSentiment: "positive",
      mainSentimentPercent: 38,
    },
    duration: {
      avg: 102
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 36,
    },
    touchPoint: {
      text: { type: 'text', value: "60%"},
      voice: { type: 'voice', value: "77%"},
    },
    otherTopics: [
      {
        topicId: "7854",
        name: "matière première",
        percent: 40
      },
      {
          topicId: "6981",
          name: "pièce manquante",
          percent: 8
      },
      {
          topicId: "2354",
          name: "livraison machine",
          percent: 75
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Transport",
    category: "LOGISTIC",
    conversations: 35,
    comparePreviousPeriod: {
      atmosphere: "positive",
      conversations: 10.1,
      durationAvg: -8
    },
    atmosphere: {
      mainSentiment: "positive",
      mainSentimentPercent: 26,
    },
    duration: {
      avg: 202
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 36,
    },
    touchPoint: {
      text: { type: 'text', value: "70%"},
      voice: { type: 'voice', value: "57%"},
    },
    otherTopics: [
      {
        topicId: "64581",
        name: "moteur en panne",
        percent: 30
      },
      {
          topicId: "34518",
          name: "pièce manquante",
          percent: 43
      },
      {
          topicId: "461597",
          name: "prix pièce",
          percent: 55
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Refunds",
    category: "Sales, Logistics",
    conversations: 172,
    comparePreviousPeriod: {
      atmosphere: "positive",
      conversations: 50,
      durationAvg: 20
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 10,
    },
    duration: {
      avg: 100
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 40,
    },
    touchPoint: {
      text: { type: 'text', value: "100%"},
      voice: { type: 'voice', value: "88%"},
    },
    otherTopics: [
      {
        topicId: "14",
        name: "cas oui hésitez",
        percent: 58
      },
      {
          topicId: "28",
          name: "accord montant tarif",
          percent: 10
      },
      {
          topicId: "3",
          name: "ensemble civile savoir",
          percent: 30
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Delivery",
    category: "Sales, Logistics",
    conversations: 113,
    comparePreviousPeriod: {
      atmosphere: "negative",
      conversations: -5.6,
      durationAvg: -4.5
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 72,
    },
    duration: {
      avg: 142
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 40,
    },
    touchPoint: {
      text: { type: 'text', value: "80%"},
      voice: { type: 'voice', value: "67%"},
    },
    otherTopics: [
      {
        topicId: "14",
        name: "tarif journalier",
        percent: 48
      },
      {
          topicId: "28",
          name: "acte juridique",
          percent: 40
      },
      {
          topicId: "3",
          name: "bon de commande",
          percent: 68
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Certificate",
    category: "Paperwork",
    conversations: 53,
    comparePreviousPeriod: {
      atmosphere: "negative",
      conversations: -8.2,
      durationAvg: 6
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 25,
    },
    duration: {
      avg: 142
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 40,
    },
    touchPoint: {
      text: { type: 'text', value: "90%"},
      voice: { type: 'voice', value: "57%"},
    },
    otherTopics: [
      {
        topicId: "54",
        name: "produit defectant",
        percent: 4
      },
      {
          topicId: "457",
          name: "agence voyage",
          percent: 80
      },
      {
          topicId: "6357",
          name: "frais livraison gratuit",
          percent: 19
      }
    ]
  },
  {
    topicId: generateRandomString(),
    name: "Product info",
    category: "SALES",
    conversations: 32,
    comparePreviousPeriod: {
      atmosphere: "positive",
      conversations: 4.3,
      durationAvg: 1.2
    },
    atmosphere: {
      mainSentiment: "negative",
      mainSentimentPercent: 32,
    },
    duration: {
      avg: 186
    },
    relatedTopics: {
        topicId: generateRandomString(),
        name: "topic there 2",
        percent: 53,
    },
    touchPoint: {
      text: { type: 'text', value: "50%"},
      voice: { type: 'voice', value: "67%"},
    },
    otherTopics: [
      {
        topicId: "6924",
        name: "date limite",
        percent: 40
      },
      {
          topicId: "784",
          name: "prix total",
          percent: 8
      },
      {
          topicId: "124",
          name: "consommation globale",
          percent: 75
      }
    ]
  },
];

export const topicsData = {
  topics: topics.map((topic, index) => ({
    ...topic,
    topicId: "t00" + index,
  }))
};

const messages = [
  {
    text: "bonjour",
    time: "10:45",
    from: "user",
    atmosphere: {
      sentiment: "positive"
    }
  },
  {
    text: "bonjour. Que puis-je faire pour vous?",
    time: "10:45",
    atmosphere: {
      sentiment: "positive"
    }
  },
  {
    text: "j'ai un soucis avec mon téléphone. il ne s'est plus rédemarrer depuis hier soir",
    time: "10:46",
    from: "user",
    atmosphere: {
      sentiment: "negative"
    }
  },
  {
    text: "Quelle est la marque de votre téléphone?",
    time: "10:46",
    atmosphere: {
      sentiment: "positive"
    }
  },
  {
    text: "Xiaomi Redmin Note 9 Pro",
    time: "10:47",
    from: "user",
    atmosphere: {
      sentiment: "positive"
    }
  },
  {
    text: "C'est quoi la version du système?",
    time: "10:47",
    atmosphere: {
      sentiment: "positive"
    }
  },
  {
    text: "Android 12 je crois",
    time: "10:47",
    from: "user",
    atmosphere: {
      sentiment: "positive"
    }
  },
]

const conversations = [
  {
    id: generateRandomString(),
    createdAt: '17min',
    categorization: {
      mainTopic: "Politique intérieure",
      topics: [topicsData.topics[2], topicsData.topics[4]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Claire",
    duration: 112,
    agentId: "Edouard",
  },
  {
    id: generateRandomString(),
    createdAt: '23min',
    categorization: {
      mainTopic: "Economie générale",
      topics: [topicsData.topics[1], topicsData.topics[3], topicsData.topics[5]]
    },
    atmosphere: {
      sentiment: "negative"
    },
    userId: "Marie",
    duration: 45,
    agentId: "Edouard",
  },
  {
    id: generateRandomString(),
    createdAt: '2h',
    categorization: {
      mainTopic: "Medecine",
      topics: [topicsData.topics[2]]
    },
    atmosphere: {
      sentiment: "negative"
    },
    userId: "Jean",
    duration: 302,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '36min',
    categorization: {
      mainTopic: "Science politique",
      topics: [topicsData.topics[4], topicsData.topics[0]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Benoît",
    duration: 109,
    agentId: "Martine",
  },
  {
    id: generateRandomString(),
    createdAt: '12min',
    categorization: {
      mainTopic: "Physique quantique",
      topics: [topicsData.topics[3]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Thomas",
    duration: 96,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '12min',
    categorization: {
      mainTopic: "Physique quantique",
      topics: [topicsData.topics[5]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Emilie",
    duration: 135,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '5h',
    categorization: {
      mainTopic: "Energie renouvelable",
      topics: [topicsData.topics[3], topicsData.topics[5]]
    },
    atmosphere: {
      sentiment: "negative"
    },
    userId: "Philippe",
    duration: 25,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '16h',
    categorization: {
      mainTopic: "Matière première",
      topics: [topicsData.topics[4], topicsData.topics[1]]
    },
    atmosphere: {
      sentiment: "negative"
    },
    userId: "Manuel",
    duration: 145,
    agentId: "Edouard",
  },
  {
    id: generateRandomString(),
    createdAt: '6s',
    categorization: {
      mainTopic: "Immobilier",
      topics: [topicsData.topics[0]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Carole",
    duration: 145,
    agentId: "Edouard",
  },
  {
    id: generateRandomString(),
    createdAt: '49s',
    categorization: {
      mainTopic: "Cuisine",
      topics: [topicsData.topics[1], topicsData.topics[5]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Arlette",
    duration: 156,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '2j',
    categorization: {
      mainTopic: "Hygiène",
      topics: [topicsData.topics[4], topicsData.topics[1], topicsData.topics[3], topicsData.topics[5]]
    },
    atmosphere: {
      sentiment: "negative"
    },
    userId: "Melanie",
    duration: 185,
    agentId: "Hans",
  },
  {
    id: generateRandomString(),
    createdAt: '5j',
    categorization: {
      mainTopic: "Informatique",
      topics: [topicsData.topics[2], topicsData.topics[4]]
    },
    atmosphere: {
      sentiment: "positive"
    },
    userId: "Jacque",
    duration: 185,
    agentId: "Hans",
  },  
];

export const conversationsData = {
  topic: topicsData.topics[0],
  conversations: conversations.map((conversation, index) => ({
     ...conversation,
     conversationId: 'c00' + index,
     messages,
  }))
};